import { OPERATOR_LABELS, type FilterQuery, type FilterRule } from '@viewer/lib/filter'
import type { DimensionMode } from '@viewer/lib/itemDimensions'

// ---------------------------------------------------------------------------
// Vocabulario do construtor de regras: os nomes dos criterios em PT-PT e
// as funcoes puras que quem usa o construtor precisa (criar, validar,
// resumir). Separado do componente porque e importado tambem por quem nao
// desenha nada (o resumo de um lado da matriz de conflitos, por exemplo).
// ---------------------------------------------------------------------------

export const DIMENSION_LABELS: Record<DimensionMode, string> = {
  entity: 'Entidade IFC',
  predefinedType: 'PredefinedType',
  storey: 'Storey / Piso',
  system: 'Sistema / Grupo',
  material: 'Material',
  type: 'Tipo (IfcType)',
  property: 'Propriedade',
}

export function newFilterRule(): FilterRule {
  return {
    id: Math.random().toString(36).slice(2, 10),
    dimension: 'entity',
    operator: 'equals',
    values: [],
  }
}

/** Query nova, com uma regra vazia. */
export function newFilterQuery(): FilterQuery {
  return { combinator: 'and', rules: [newFilterRule()] }
}

/** Uma query so conta quando tem regras utilizaveis. Mesma condicao que
 *  o `evaluateFilterQuery` aplica antes de correr. */
export function hasUsableRules(query: FilterQuery | null | undefined): boolean {
  if (!query) return false
  return query.rules.some((r) => {
    if (r.dimension === 'property' && !(r.propertyKey ?? '').trim()) return false
    return r.values.some((v) => v.trim() !== '')
  })
}

/** Resumo curto de uma query, para cabecalhos colapsados. */
export function describeFilterQuery(
  query: FilterQuery | null | undefined,
): string {
  if (!query || query.rules.length === 0) return 'sem regras'
  const parts = query.rules
    .filter((r) => r.values.some((v) => v.trim() !== ''))
    .map((r) => {
      const dim =
        r.dimension === 'property'
          ? (r.propertyKey ?? '').trim() || 'propriedade'
          : DIMENSION_LABELS[r.dimension]
      return `${dim} ${OPERATOR_LABELS[r.operator]} ${r.values.join(', ')}`
    })
  if (parts.length === 0) return 'sem regras'
  return parts.join(query.combinator === 'and' ? ' E ' : ' OU ')
}
